<template>
	<div class="test_report">
        <div v-if="reportData" class="report_item">
			<DownloadProgress :totalPages="totalPages" :currentPage="currentPage" v-if="isDownloading"></DownloadProgress>
			<div class="pdf" id="pdfDom" style="background-color:#E8E8E8;" >
				<!-- 封面 -->
				
				<div class="page_shadow page_shadow_cover">
					<div class="page_cover pdf-page">
						<div class="logoBox">
							<img :src="imgLogo" alt="">
						</div>
						<div class="header">
							<h3>升学途径分析报告</h3>
							
						</div>
						<div class="main">
							<p>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：{{student.name?'':student.name}}</p>
							<p>学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;校：{{student.school}}</p>
							<p>高考年份：{{student.gkYear}}</p>
							<p>报告时间：{{student.reportTime}}</p>
							<p class="eng">Development Path Analysis Report</p>
						</div>
						
					</div>
				</div>
				<!-- 前言 -->
				<div class="page_shadow" id="page1">
					<div class="page pdf-page">
						<div class="top_header">
							<img class="top_logo" :src="imgLogo" alt="">
							<div class="line_box">
								<img class="line_border" src="../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
								<p>
									<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
									前言
								</p>
							</div>
						</div>
						<div class="line_border_title">
							<p>前言</p>
							<p class="line"></p>
						</div>
						<h5 class="header">
							
						</h5>
						<div class="content">	
							<div class="main">
								<p>高考是影响考生人生发展的一次重要事件，历来都是学生本人和家长乃至全社会最为重视的事情。高考作为基础教育的“指挥棒”，自从1977年恢复高考以来，关于高考的变革都影响着教育的基本方向和教学策略。相比于原来“千军万马过独木桥”的“裸分时代”，现在随着新高考改革的推进，越来越多元的升学方式成为了可能。那么相应的，探索不同的升学途径，拓展更多升学可能性，选择最适合自己的方式，以最优方式配置学习资源，是每个考生应该优先考虑的问题之一。可以说，明确目标和明确路径是一切良好计划的基石，也是最终实现结果的根本保证。</p>
								<p>“知彼知己，百战不殆”，考生需要对自己的情况和所面临的问题有全面而准确的认识，才能更合理地做出选择和决策。因此，升学途径分析是基于对考生基本情况和当下实行的多种政策条件的对照分析，探索符合和不符合考生的升学途径，给出合理建议的有效方法。当然，政策会根据实际情况有所调整，考生本人的基本情况也可能会有所变化，因此需要对报告结果进行灵活分析判断，并实际了解当年最新政策要求，以免错过升学机会。</p>
								<p>祝愿所有考生都能取得满意的成绩和美好的结果！</p>
							</div>
							<div class="msg_footer">
								<p>
									<span>*</span>版权声明
								</p>
								<p>本报告内容属于个人隐私，请注意保密</p>
								<p>本报告必须在专业咨询师的指导下使用</p>
								<p>本报告的所有权都受到版权保护，未经授权不得擅自转载、挪用、复制、刊印等，不得用于商业或非商业用途</p>
							</div>
						</div>
						<div class="big_page_number"></div>
					</div>
				</div>
				<div class="page_shadow">
					<div class="page pdf-page">
						<div class="top_header">
							<img class="top_logo" :src="imgLogo" alt="">
							<div class="line_box">
								<img class="line_border" src="../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
								<p>
									<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
									目录
								</p>
							</div>
						</div>
						<div class="line_border_title">
							<p>目录 <span style="color:#666;font-size:20px">Catalog</span></p>
							<p class="line" style="width:170px"></p>
						</div>
						<div class="header">
							<h5 class="page_header">
							
							</h5>
						</div>
						<div class="content" id="catalog_1">
							<div class="big_title_box color_mulu1" >
								<p class="big_title"><span></span>Part.1 升学途径分析结果概述</p>
								<div class="line border_line1">
									<img src="../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
								</div>
								<div class="page_number">1</div>
							</div>
							<div class="big_title_box header_title_page2 color_mulu2">
								<p class="big_title"><span></span>Part.2 符合的升学途径</p>
								<div class="line border_line2">
									<img src="../../../../public/imgs/wayToStudyWays/report/border_de2.png" alt="">
								</div>
								<div class="page_number"></div>
							</div>

							<div v-if="index < 22" class="small_title_box page_mulu" v-for="(item, index) in reportData.tallyWith" :key="item.id">
								<div class="small_title">2.{{index + 1}} {{item.title}}</div>
								<div class="line ">
									<img src="../../../../public/imgs/wayToStudyWays/report/border_de3.png" alt="">
								</div>
								<div class="page_number"></div>
							</div>
							
							<div v-if="recommendNum < 22" class="big_title_box header_title_page3 color_mulu3" >
								<p class="big_title"><span></span>Part.3 不符合的升学途径</p>
								<div class="line border_line3">
									<img src="../../../../public/imgs/wayToStudyWays/report/border_de4.png" alt="">
								</div>
								<div class="page_number"></div>
							</div>
							<div v-if="recommendNum < 20 && (recommendNum+index) < 20 " class="small_title_box page_mulu" v-for="(item, index) in reportData.nonConformity" :key="item.id">
								<div class="small_title">3.{{index + 1}} {{item.title}}</div>
								<div class="line">
									<img src="../../../../public/imgs/wayToStudyWays/report/border_de3.png" alt="">
								</div>
								<div class="page_number"></div>
							</div>
							
							
						</div>	
					</div>
				</div>
				
				<div class="page_shadow">
					<div class="page pdf-page">
						<div class="top_header">
							<img class="top_logo" :src="imgLogo" alt="">
							<div class="line_box">
								<img class="line_border" src="../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
								<p>
									<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
									目录
								</p>
							</div>
						</div>
						<h5 class="header">	
						</h5>
						<div class="content" id="catalog_2">
							<div v-if="index >= 22" class="small_title_box page_mulu" v-for="(item, index) in reportData.tallyWith" :key="item.id">
								<div class="small_title">2.{{index + 1}} {{item.title}}</div>
								<div class="line ">
									<img src="../../../../public/imgs/wayToStudyWays/report/border_de3.png" alt="">
								</div>
								<div class="page_number"></div>
							</div>
							<div v-if="recommendNum >= 22 && reportData.nonConformity !== []" class="big_title_box header_title_page3 color_mulu3" >
								<p class="big_title"><span></span>Part.3 不符合的升学途径</p>
								<div class="line border_line3">
									<img src="../../../../public/imgs/wayToStudyWays/report/border_de4.png" alt="">
								</div>
								<div class="page_number"></div>
							</div>
							<div v-if="(recommendNum+unRecommendNum) >= 20 && (recommendNum+index) >= 20 " class="small_title_box page_mulu" v-for="(item, index) in reportData.nonConformity" :key="item.id">
								<div class="small_title">3.{{index + 1}} {{item.title}}</div>
								<div class="line">
									<img src="../../../../public/imgs/wayToStudyWays/report/border_de3.png" alt="">
								</div>
								<div class="page_number"></div>
							</div>

							
						
						</div>
					</div>
				</div>
				<div class="page_shadow" id="page2">
					<div class="page pdf-page">
						<div class="top_header">
							<img class="top_logo" :src="imgLogo" alt="">
							<div class="line_box">
								<img class="line_border" src="../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
								<p>
									<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
									升学途径分析
								</p>
							</div>
						</div>
						<h5 class="header bg_header_title1" >
							Part.1 升学途径分析结果总览
						</h5>
						<h6 class="page_title_2">
							<span>升学途径分析结果总览</span>
							<span class="arrow arrow1"></span>
						</h6>
						<div class="line-box">
							<p class="">
								<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
								通过对您的个人情况的深入分析，您的升学途径分析结果如下：
							</p>
						</div>
						<div class="duibi">
							<div class="duibi_text">
								<p>符合的升学途径</p>
								<p>不符合的升学途径</p>
							</div>
							<div class="carEcharts">
								<div class="carEcharts_left" :style="{width:(100/reportData.channelCount.all)*reportData.channelCount.tallyWithNumber+'%'}">
									<p>{{reportData.channelCount.tallyWithNumber}}</p>
								</div>
								<div class="carEcharts_right" :style="{width:(100/reportData.channelCount.all)*reportData.channelCount.nonConformityNumber+'%'}">
									<p>{{reportData.channelCount.nonConformityNumber}}</p>
								</div>
							</div>
							<div class="duibi_jieshao">
								<p>升学途径一共27种，您符合其中的<span>{{reportData.channelCount.tallyWithNumber}}</span>种，可以作为优先考虑的升学途径；您暂不符合的有<span>{{reportData.channelCount.nonConformityNumber}}</span>种，其中一些限制条件目前不满足，可以了解后做出相应调整，作为备选升学途径。</p>
							</div>
						</div>
						<div class="content">
							<div class="page_js">
								<div class="page_js_title conform_color">
									符合的升学路径
								</div>
								<ul>
									<li v-for="(item,index) in tallyWith" :key="index">{{item.typeName}}升学途径:
										<span v-for="(child,index) in item.children" :key="index">{{child.title}}</span>
									</li>
									<!-- <li>特殊类型升学途径:<span>高校专项计划、地方专</span></li>
									<li>艺体类升学途径:<span>无</span></li>
									<li>提前批次升学途径:<span>小语种招生</span></li>
									<li>境外升学途径:<span>无</span></li> -->
								</ul>
							</div>
							<div class="page_js">
								<div class="page_js_title no_conform_color">
									不符合的升学路径
								</div>
								<ul>
									<li v-for="(item,index) in nonConformity" :key="index">{{item.typeName}}升学途径:
										<span v-for="(child,index) in item.children" :key="index">{{child.title}}</span>
									</li>	
									<!-- <li>特殊类型升学途径:<span>高校专项计划、地方专</span></li>
									<li>艺体类升学途径:<span>无</span></li>
									<li>提前批次升学途径:<span>小语种招生</span></li>
									<li>境外升学途径:<span>无</span></li> -->
								</ul>
							</div>
						</div>
						<div class="big_page_number">1</div>
					</div>
				</div>

				<div class="page_shadow" v-for="(item, index) in reportData.tallyWith" :key="item.id" :id="'page' + (index + 3)">
					<div class="page pdf-page">
						<div class="top_header">
							<img :src="imgLogo" alt="" class="top_logo">
							<div class="line_box">
								<img class="line_border" src="../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
								<p>
									<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
									符合的升学途径
								</p>
							</div>
						</div>
					
						<h5 class="header bg_header_title2" :class="'headerTwo'+index" v-if="index==0">
							Part.2 符合的升学途径
						</h5>
						<div class="content career_page">	
							<h6 class="page_title_2">
								<span>{{item.title}}</span>
								<span class="arrow arrow2"></span>
							</h6>
							<div class="condition">
								<div class="line-box">
									<p class="">
										<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
										类型：{{item.typeName}}
									</p>
								</div>
								<p class="condition-text">{{item.details}}</p>
							</div>
							<div class="condition">
								<div class="line-box">
									<p class="">
										<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
										报考条件
									</p>
								</div>
								<div class="condition-text" v-html="item.condition"></div>
							</div>
							<div class="condition">
								<div class="line-box">
									<p class="">
										<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
										备考须知
									</p>
								</div>
								<div class="condition-text" v-html="item.notice"></div>
								<!-- <p class="condition-text"></p> -->
							</div>
						</div>
						<div class="big_page_number">{{index + 2}}</div>
					</div>
				</div>
				<div class="page_shadow" v-for="(item, index) in reportData.nonConformity" :key="item.id" :id="'page' + (index + 3 + reportData.tallyWith.length)">
						
					<div class="page pdf-page">
						<div class="top_header">
							<img class="top_logo" :src="imgLogo" alt="">
							<div class="line_box">
								<img class="line_border" src="../../../../public/imgs/wayToStudyWays/report/border_de.png" alt="">
								<p>
									<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
									不符合的升学途径
								</p>
							</div>
						</div>
					
						<h5 class="header bg_header_title3" :class="'headerThree'+index" v-if="index==0">
							Part.3 不符合的升学途径
						</h5>
						<div class="content career_page">	
							<h6 class="page_title_2">
								<span>{{item.title}}</span>
								<span class="arrow arrow3"></span>
							</h6>
							<div class="condition">
								<div class="line-box">
									<p class="">
										<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
										类型：{{item.typeName}}
									</p>
								</div>
								<p class="condition-text">{{item.details}}</p>
							</div>
							<div class="condition">
								<div class="line-box">
									<p class="">
										<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
										报考条件
									</p>
								</div>
								<div class="condition-text" v-html="item.condition"></div>
							</div>
							<div class="condition">
								<div class="line-box">
									<p class="">
										<img src="../../../../public/imgs/cepingreport/page_feng.png" alt="">
										备考须知
									</p>
								</div>
								<div class="condition-text" v-html="item.notice"></div>
								
							</div>
						</div>
						<div class="big_page_number">{{index + 2 +recommendNum}}</div>
					</div>
				</div>
				
				<div class="page_shadow">
					<div class="page_cover2 pdf-page">
						<img src="../../../../public/imgs/wayToStudyWays/report/bef.png" alt="升学途径">
					</div>
				</div>
			</div>
		</div>
		<div v-else class="no_data">
			<img src="imgs/wayToStudy/analysis_test/report/null.png" /><p>抱歉，暂无相关数据</p>
			<!-- <div >
				
			</div> -->
		</div>
        <div class="get_pdf">
            <div class="inner">
                <div v-if="down"  class="btn_pdf" v-on:click="getPdf(htmlTitle);isDownloading = true;">下载报告</div>
            </div>
        </div>
	</div>       
</template>
<style scoped>
.top_header{
	display: flex;
    height: 42px;
    margin-bottom: 40px;
}
.top_header .top_logo{
	width: 96px;
	height: 42px;
}
.top_header .line_box{
	padding-top: 20px;
    padding-bottom: 2px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 1px dashed #17abbd;
}
.line_box .line_border{
	position: absolute;
    top: 120px;
    width: 625px;
	display: none;
}
.top_header .line_box p{
    line-height: 20px;
    float: right;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.line_border_title p{
	line-height: 36px;
    color: #2f2f2f;
    font-weight: 500;
    font-size: 24px;
}
.line_border_title .line{
	margin-top: 7px;
    height: 2px;
    width: 60px;
    background: -webkit-gradient(linear,left top,right top,from(#ffb23a),to(#19afbf));
    background: linear-gradient(
90deg
,#ffb23a,#19afbf);
}
.color_mulu1{
	color: #14A9DF;
}
/* .border_line1{
	border-top: 1px dashed #14A9DF;
} */
.color_mulu2{
	color: #1CA4B6;
}
/* .border_line2{
	border-top: 1px dashed #1CA4B6;
} */
.color_mulu3{
	color: #F6A724;
}
/* .border_line3{
	border-top: 1px dashed #F6A724;
} */

.bg_header_title1{
	background: #14A9DF;
}
.bg_header_title2{
	background: #1CA4B6;
}
.bg_header_title3{
	background: #F6A724;
}

.page_title_2{
	display: flex;
    height: 32px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 10px;
}
.page_title_2 span{
    line-height: 32px;
    font-size: 20px;
}
.page_title_2 .arrow{
    display: block;
    margin-left: 10px;
    width: 0;
    height: 0;
    
}
.page_title_2 .arrow1{
	border-top: 9px solid transparent;
    border-left: 14px solid #14A9DF;
    border-bottom: 9px solid transparent;
}
.page_title_2 .arrow2{
	 border-top: 9px solid transparent;
    border-left: 14px solid #1CA4B6;
    border-bottom: 9px solid transparent;
}
.page_title_2 .arrow3{
	 border-top: 9px solid transparent;
    border-left: 14px solid #F6A724;
    border-bottom: 9px solid transparent;
}

.line-box{
	margin: 30px 0 15px;
}
.line-box p{
	font-size: 16px;
}

.duibi_text{
	display: flex;
	justify-content: space-between;
}
.duibi_text p{
	height: 30px;
	font-size: 16px;
}
.duibi_text p:first-child{
	color: #2DABBB;
}
.duibi_text p:last-child{
	color: #F6A724;
}
.carEcharts{
	height: 20px;
	border-radius: 30px;
	background: #e6e6e6;
	display: flex;
	justify-content: space-between;
}
.carEcharts .carEcharts_left{
	height: 20px;
	/* width: 100px; */
	border-radius: 10px 0px 0px 10px;
	/* border-top-left-radius: 10px;
	border-bottom-left-radius: 10px; */
	background: #2DABBB;
	z-index: 22;
	text-align: center;
}
.carEcharts .carEcharts_right{
	height: 20px;
	/* width: 200px; */
	border-radius: 0px 10px 10px 0px;
	background: #F6A724;
	z-index: 22;
	text-align: center;
}
.carEcharts p{
	color: #fff;
	height: 20px;
	line-height: 20px;
}
.duibi{
	margin-bottom: 45px;
}
.duibi_jieshao {
	margin-top: 15px;
}
.duibi_jieshao p{
	font-size: 16px;
	line-height: 2;
	text-indent: 2em;
}
.duibi_jieshao span{
	font-size: 18px;
}
.duibi_jieshao span:first-child{
	color: #2DABBB;
}
.duibi_jieshao span:last-child{
	color: #F6A724;
}
.page_js{
	margin-bottom: 45px;
    height: auto;
    background: #f5f5f5;
    border-radius: 6px;
    padding: 15px 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
}
.page_js ul{
	margin-top: 15px;
}
.page_js ul li{
	color: #969696;
	line-height: 2;
}
.page_js ul li span{
	margin-left: 10px;
	color: #000;
}
.page_js_title{
	font-size: 18px;
	width: auto;
    padding: 0 15px;
    height: 30px;
    background: #2DABBB;
    border-radius: 6px;
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: absolute;
    top: -15px;
}
.conform_color{
	background: #2DABBB;
}
.no_conform_color{
	background: #F6A724;
}
.page_cover2{

}
</style>


<style type="text/css" lang='less' scoped>
.test_report {
	width: 100%;
	padding-top: 20px;
	// 
	.report_item{
       background-color: #E8E8E8;
	}
	.get_pdf {
		height: 0px;
		width: 100%;
		position: fixed;
		top: 30%;
		.inner {
			// width: 900px;
			margin: 0 auto;
			position: relative;
			.btn_pdf {
				position: absolute;
				padding: 5px 10px;
				right: -40px;
				width: 20px;
				text-align: center;
				background-color: #2c8ffc;
				color: #fff;
				cursor: pointer;
				border-radius: 5px;
			}
		}
	}
	.pdf {
		width: 100%;
		// line-height: 0px;
		margin: 0 auto;
		background-color: #fff;
		.page_shadow{
			-webkit-box-shadow: 0px 0px 10px #666;
			-ms-box-shadow: 0px 0px 10px #666;
			-moz-box-shadow: 0px 0px 10px #666;
			// height: 1300px;
			width: 100%;
			margin-bottom: 20px;
		}
		.page_shadow_cover{
			background: #fff;
		}
		.page_cover {
			// height: 1230px;
			padding-top: 70px;
			background: url(../../../../public/imgs/wayToStudyWays/report/cover.png) no-repeat;
			background-size: 100%;
			background-position: bottom center;
			position: relative;
			.logoBox{
				position: absolute;
				width: 140px;
				height: 70px;
				top: 40px;
				left: 50px;
			}
			.header {
			    padding-top: 25px;
                height: 259px;
				text-align: center;
				h3 {
					line-height: 100px;
					font-size: 24px;
					color: #333;
					margin-bottom: 20px;
					font-weight: 600;
				}
				
			}
			.main {
				    height: 246px;
					padding: 30px 0px 0px;
					// text-align: center;
					display: flex;
					flex-direction: column;
					// align-items: center;
					justify-content: flex-end;
					box-sizing: border-box;
					padding-left: 51px;
				p {
					line-height: 28px;
					font-size: 14px;
					color: #fff;
				}
				p.eng {
					font-size: 17px;
					line-height: 40px;
					display: inline-block;
					// text-align: center;
					border-radius: 20px;
					color: #fff;
					background-color: #09A8DE;
					// padding: 0 20px;
					// margin-top: 50px;
				}
			}
		}
		.page {
			height: 1300px;
			padding: 40px 20px;
			box-sizing: border-box;
			// padding-top: 140px;
			// background: url(/imgs/wayToStudy/analysis_test/report/bg.png) no-repeat;
			// background-size: 900px 1300px;
			background-color: #fff;
			position: relative;
			
			// 大标题
			.header {
				color: #fff;
				font-size: 18px;
				text-align: left;
				margin-bottom: 30px;
				line-height: 50px;
				padding-left: 15px;
			}
			.header_detail {
				text-align: center;
				line-height: 60px;
			}
			.content {
				// padding: 30px 100px;
				.big_title_box {
					display: flex;
					line-height: 50px;
					.big_title {
						position: relative;
						// padding-left: 30px;
						padding-right: 20px;
						font-weight: 600;
						// background: url(/imgs/wayToStudy/analysis_test/report/icon_biaoti.png) 0px center no-repeat;
						span {
							height: 50px;
							font-size: 24px;
							line-height: 50px;
							font-weight: 600;
							text-align: center;
							width: 30px;
							position: absolute;
							left: 0px;
							top: -6px;
						}	
						font-size: 16px;
						// color: #000;
					}
					.line {
						flex: 1;
						// border-top: 1px dashed #000;
						margin: auto 0;
					}
					.page_number {
						padding-left: 10px;
						font-size: 18px;
					}
				}
				.small_title_box {
					line-height: 40px;
					padding-left: 40px;
					font-size: 16px;
					color: #666;
					display: flex;
					.small_title {
						padding-right: 20px;
						// flex: 1;
					}
					.line{
						flex: 1;
						margin: auto 0;
						// border-top: 1px dashed #000;
					}
					.page_number {
						padding-left: 10px;
					}
				}
				.echats_box {
					height: 260px;
					display: flex;
					justify-content: space-between;
					.circle1 {
						width: 240px;
						height: 240px;
						position: relative;
						.box {
							position: absolute;
							text-align: center;
							width: 240px;
							top: 60px;
							color: #006ec6;
							font-size: 20px;
							line-height: 30px;
							.box_title {
								margin-bottom: 20px;
							}
							.num {
								font-size: 30px;
								font-weight: 600;
								line-height: 30px;
								span {
									&:nth-child(2) {
										color: #333;
									}
								}
							}
						}
					}
					.circle2 {
						.circle1;
						.box {
							color: ;
						}
					}
				}
				.page2_detail {
					line-height: 40px;
					font-size: 20px;
					font-weight: 600;
					margin-bottom: 20px;
					.tuijian {
						color: #056dba;
					}
					.fuhe {
						color: #ff1360;
					}
				}
				.main {
					margin-bottom: 30px;
					margin-top: 30px;
					p {
						line-height: 25px;
						font-size: 14px;
						color: #333;
						text-indent: 2em;
						margin-bottom: 5px;
					}
				}
				.table_gaisu {
					margin-bottom: 30px;
					tr {
						height: 50px; 
						td {
							text-align: center;
						}
					}
				}
				.explain {
					padding: 20px;
					border-radius: 5px;
					background-color: #DEEBF7;
					.title {
						padding-left: 20px;
						font-size: 22px;
						line-height: 36px;
						color: #0070C0;
						margin-bottom: 10px;
						border-left: 3px solid #0070C0;
					}
					p {
						line-height: 24px;
						font-size: 16px;
						color: #333;
					}
				}
				// 小标题
				.condition {
					margin-bottom: 30px;
					.condition-text{
						text-indent: 2em;
						line-height: 1.6;
						font-size: 14px;
						color: #333;
					}
				}
				// 备考须知
				
				.must_know {
					padding: 20px;
					background-color: #DEEBF7;
					border-radius: 5px;
					.title {
						font-size: 22px;
						line-height: 50px;
						color: #0070C0;
						margin-bottom: 10px;
					}
					p {
						line-height: 24px;
						font-size: 14px;
						color: #333;
					}
				}
				.msg_footer{
					height: 500px;
					p{
						height: 30px;
						line-height: 30px;
						color: #8a8a8a;
						span{
							color: red;
						}
					}
				}
				// 温馨提示
				.reminder {
					p {
						line-height: 30px;
						text-indent: 2em;
						font-size: 16px;
						color: #333;
					}
				}
			}
			.big_page_number {
				position: absolute;
				bottom: 0px;
				left: 0px;
				width: 100%;
				line-height: 40px;
				font-size: 16px;
				color: #000;
				text-align: center;
			}
		}
	}
}
// 移动端

.test_report{
	padding: 0;
}
.no_data{
	font-size: 14px;
    text-align: center;
    /* padding-top: 100%; */
    color: gray;
    background: #fff;
    height: 100%;
    position: absolute;
    width: 100%;
    padding-top: 110px;
    box-sizing: border-box;
	> img{
		width: 26px;
		height: 26px;
		margin-right: 5px;
	}
	p{
		margin: 6px;
	}
	
}
</style>
<script>
import DownloadProgress from '../../../components/DownloadProgress.vue';
// 引用jquery写的圆环插件
import circleChart from '../../../../public/statics/js/circleChart.min.js'
export default {
	components: { DownloadProgress },
    props: [],
    data() {
        return {
        	isDownloading: false, //是否正在下载
            totalPages: 1, //总页数
            currentPage: 0,//当前页
        	htmlTitle: '',
        	currentTime: '',
        	reportData: null,
        	// 报告封面
        	student: null,
        	// 推荐的升学途径数量
        	recommendNum: 0,
        	// 不推荐的升学途径数量
        	unRecommendNum: 0,
			tallyWith:[],//符合
			nonConformity:[],//不合符
			imgLogo:'',
			down:false,
			isShowreport:true,

        }
    },
    methods: {
    	// 获取测试结果同一项目下  		
		getReport2(){
			var token = window.sessionStorage.getItem('ymtxToken')||window.localStorage.getItem('localtoken');
			let _this = this
			this.$ajax.post(this.G_testuri+'/report/getReportByStudentInfo',{
			},{
				 headers:{
                        token: token
                    }
			})
			.then(function(res){
				// console.log(res)
				if(res.data.code === 2000){
					_this.isShowreport = true;
					let data = res.data.data;
					_this.reportData = data.report;
					_this.student = data.student;
					_this.recommendNum = data.report.channelCount.tallyWithNumber
					_this.unRecommendNum = data.report.channelCount.nonConformityNumber
					_this.imgLogo = data.student.headerLogo
					_this.getTallyWithArr(_this.reportData.tallyWith)
					_this.getNonConformityArr(_this.reportData.nonConformity)					
					_this.htmlTitle = data.student.name + '的升学途径分析报告';					
					_this.$nextTick(() => {						
							_this.countListPage()               		
					})
				}else if(res.data.code === 1010){

					_this.isShowreport = false;
				}						
			})
		},
		// 获取测试结果 -- 代理商后台
		getReport3(local,agentId){
			var token = window.sessionStorage.getItem('ymtxToken')||window.localStorage.getItem('localtoken');
			let _this = this
			this.$ajax.post(this.G_testuri+'/report/getReportByUserNameAndAgentId',{
				username:local,
				agentId:agentId,
			})
			.then(function(res){
				console.log(res)
				let data = res.data.data;
				_this.reportData = data.report;
                _this.student = data.student;
				_this.recommendNum = data.report.channelCount.tallyWithNumber
				_this.unRecommendNum = data.report.channelCount.nonConformityNumber
				_this.imgLogo = data.student.headerLogo
				_this.getTallyWithArr(_this.reportData.tallyWith)
				_this.getNonConformityArr(_this.reportData.nonConformity)
				
				_this.htmlTitle = data.student.name + '的升学途径分析报告';
				
				_this.$nextTick(() => {
						
						_this.countListPage()
						
                		
                	})
			})
		},
		getTallyWithArr(arr){
			let obj = {}
			console.log(arr)
			arr.forEach((item,index) => {
				let {typeName} = item
				if(!obj[typeName]) {
					obj[typeName] ={
						typeName,
						children:[],
					}
				}
				obj[typeName].children.push(item)
			});
			this.tallyWith = Object.values(obj)

		},
		getNonConformityArr(arr){
			let obj = {}
			console.log(arr)
			arr.forEach((item,index) => {
				let {typeName} = item
				if(!obj[typeName]) {
					obj[typeName] ={
						typeName,
						children:[],
					}
				}
				obj[typeName].children.push(item)
			});
			this.nonConformity = Object.values(obj)
		

		},
       
        goDetail(url) {
            let {href} = this.$router.resolve({
                path: url
            })
            window.open(href, '_blank');
        },
		countListPage(){
			// let one = $('.header0').parents('.pdf-page').find('.big_page_number').text()
			let two = $('.headerTwo0').parents('.pdf-page').find('.big_page_number').text()
			let three = $('.headerThree0').parents('.pdf-page').find('.big_page_number').text()

			$('.header_title_page2').find('.page_number').html(two)
			$('.header_title_page3').find('.page_number').html(three)
			$(".career_page").each(function (idx) {//目录页数
				let number = $(this).parents('.pdf-page').find('.big_page_number').text()
				console.log(number)
				$('.page_mulu').eq(idx).find('.page_number').html(number)
			
				
			}) 
			
			
		}
    },
    watch: {
    },
    created() {
    	// this.getReport();
		// this.getLogo(this.$route.query.username,this.$route.query.agentId);
		// console.log(this.$route.query.username)				
    },
    mounted() {		
    	// console.log($('#circle2'))s
		// console.log(this.$route.query.username,this.$route.query.agentId);
		// console.log();
        if(this.$route.query.username&&this.$route.query.agentId){
			this.down = true;
			this.getReport3(this.$route.query.username,this.$route.query.agentId)
		}else{
			this.down = false;
			this.getReport2()
		}
    }
}
</script>
